import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Moment from 'react-moment';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ProductTerms = (props: any) => {

  const [events, setEvents] = useState<any>([]);

  const eventList: any[] = [];

  const title: any[] = [];

  const services = new Services();

  useEffect(()=>{

    // services.getFreeTermsType(props.id).then((value: any) => {
    //
    //   setEvents(value);
    //
    //   console.log(value)
    //
    // });

    services.getFreeTerms().then((value: any) => {

      const newEvents: any[] = [];

      console.log(value);

      value.map((val: any) => {

        if(val.product.id == props.id) {

          newEvents.push(val);
        }

      })

      setEvents(newEvents)

    });

  }, [ props ])

  events.forEach((data: any, id: number, array: any[]) => {

    var link = "";

    if( !(data.capacity - data.capacityUsed < 1) && eventList.length !== 2  ){

    eventList.push(
      <div>

      <div className="d-none d-lg-block">
      <div className="row my-3">
          <div className="col-2 border-end p-4 text-secondary">
            <span className="fw-bold text-dark">Datum: </span>
            <Moment format="DD.MM.YYYY">
              {data.startDatetime}
            </Moment>
          </div>
          <div className="col-2 border-end p-4 text-secondary">
            <span className="fw-bold text-dark">Hodina vzletu: </span>
            <Moment format="HH:mm">
              {data.startDatetime}
            </Moment>
          </div>
          <div className="col-2 border-end p-4 text-secondary">
            <span className="fw-bold text-dark">Místo: </span>
              {data.place.name}
          </div>
          <div className="col-2 border-end p-4 text-secondary">
            <span className="fw-bold text-dark">Balón: </span>
              {data.balloon.name}
          </div>
          <div className="col-2 border-end p-4 text-secondary">
            <span className="fw-bold text-dark">Volná místa: </span>
            {data.capacity - data.capacityUsed}
          </div>
          <div className="col-2 d-flex flex-column justify-content-center">
            <Link className={"btn btn-sm rounded-pill btn-primary mt-2 " + link} to={"/passenger-list/"+data.id} >Rezervovat</Link>
          </div>
      </div>
      </div>

      <div className="d-block d-lg-none">
      <div className="row my-3">
        <hr />
          <div className="col-12">
            <span className="fw-bold text-primary">Datum: </span>
            <Moment format="DD.MM.YYYY">
              {data.startDatetime}
            </Moment>
          </div>
          <div className="col-12">
            <span className="fw-bold text-primary">Hodina vzletu: </span>
            <Moment format="HH:mm">
              {data.startDatetime}
            </Moment>
          </div>
          <div className="col-12">
            <span className="fw-bold text-primary">Místo: </span>
              {data.place.name}
          </div>
          <div className="col-12">
            <span className="fw-bold text-primary">Balón: </span>
              {data.balloon.name}
          </div>
          <div className="col-12">
            <span className="fw-bold text-primary">Volná místa: </span>
            {data.capacity}
          </div>
          <div className="col-12 d-flex flex-column justify-content-center pb-2">
            <Link className={"btn btn-sm rounded-pill btn-primary mt-2 " + link} to={"/passenger-list/"+data.id} >Rezervovat</Link>
          </div>
      </div>
      </div>

      </div>
    )

    }

  })

  if(events.length > 0){
    title.push(<div className="fs-2">Nejbližší termíny</div>)
    title.push(<div className="fs-2 text-primary mb-4">Pro tento let</div>)
  }else{
    title.push(<div className="fs-2">V tuto chvíli nejsou žádné volné termíny pro tento typ letu</div>)
  }


  return (
    <div className="container my-5">
          {title}
          {eventList}
    </div>
  );
}

export default ProductTerms;
